/* ── Membership Level Constants ─────────────────── */
export const MEMBERSHIP_LEVELS = {
  MEMBER: "member",
  VIP: "vip",
  VIP_PREMIUM: "vip_premium",
  SVIP: "svip",
  ADMIN: "admin",
} as const;

export type MembershipLevel =
  | "member"
  | "vip"
  | "vip_premium"
  | "svip"
  | "admin";

/* ── Display Labels ─────────────────────────────── */
export const MEMBERSHIP_LABELS: Record<string, string> = {
  member: "一般會員",
  vip: "VIP會員",
  vip_premium: "VIP尊榮",
  svip: "SVIP會員",
  admin: "管理員",
};

export function getMembershipLabel(level: string | null | undefined): string {
  if (!level) return "一般會員";
  return MEMBERSHIP_LABELS[level] || level;
}

/* ── Badge Styles (Tailwind classes) ────────────── */
export const MEMBERSHIP_STYLES: Record<string, string> = {
  member: "bg-stone-100 text-stone-600 border-stone-200",
  vip: "bg-amber-50 text-amber-600 border-amber-200",
  vip_premium: "bg-amber-100 text-amber-700 border-amber-300",
  svip: "bg-rose-50 text-rose-700 border-rose-200",
  admin: "bg-navy-50 text-navy-600 border-navy-200",
};

export function getMembershipStyle(level: string | null | undefined): string {
  if (!level) return MEMBERSHIP_STYLES.member;
  return MEMBERSHIP_STYLES[level] || MEMBERSHIP_STYLES.member;
}

/* ── VIP Zone Access ────────────────────────────── */
export function canAccessVIP(level: string | null | undefined): boolean {
  if (!level) return false;
  return level !== MEMBERSHIP_LEVELS.MEMBER && level !== MEMBERSHIP_LEVELS.ADMIN;
}

/* ── Tier Data for Dashboard ────────────────────── */
export interface TierInfo {
  level: MembershipLevel;
  name: string;
  minOrders: number;
  perks: string[];
}

export const TIER_LIST: TierInfo[] = [
  {
    level: "member",
    name: "一般會員",
    minOrders: 0,
    perks: ["體驗區認購權", "基本回報率"],
  },
  {
    level: "vip",
    name: "VIP會員",
    minOrders: 3,
    perks: ["一般區認購解鎖", "回報率 +300%"],
  },
  {
    level: "vip_premium",
    name: "VIP尊榮",
    minOrders: 5,
    perks: ["VIP區解鎖", "優先認購權", "回報率 +400%"],
  },
  {
    level: "svip",
    name: "SVIP會員",
    minOrders: 10,
    perks: ["專屬貨源", "管家服務", "回報率 +500%"],
  },
];

/* ── Options for backend select dropdowns ─────────── */
export const MEMBERSHIP_OPTIONS: { value: MembershipLevel; label: string }[] = [
  { value: "member", label: "一般會員" },
  { value: "vip", label: "VIP會員" },
  { value: "vip_premium", label: "VIP尊榮" },
  { value: "svip", label: "SVIP會員" },
  { value: "admin", label: "管理員" },
];